export default __webpack_public_path__ + "static/media/SAS Alert Tone 11.32351bb0.mp3";